import { createStore, applyMiddleware, compose } from "redux";
import { createHashHistory } from "history";
import rootReducer from "./reducers/index";

import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas/index";

import { routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";

const history = createHashHistory({ basename: "/" });
const middleWare = routerMiddleware(history);

const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    rootReducer,
    // compose(applyMiddleware(middleWare, sagaMiddleware), composeWithDevTools())
    applyMiddleware(middleWare, sagaMiddleware)
  );
  sagaMiddleware.run(rootSaga);
  return store;

  // return {
  //   ...createStore(rootReducer, applyMiddleware(middleWare, sagaMiddleware)),
  //   runSaga: sagaMiddleware.run
  // };
};

export default configureStore;
